import { render, staticRenderFns } from "./socialAccountTab.vue?vue&type=template&id=3780bb48&lang=pug"
import script from "./socialAccountTab.vue?vue&type=script&lang=js"
export * from "./socialAccountTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports